import { motion,  useAnimation } from 'framer-motion'
import React, { useContext, useEffect } from 'react'
import { FaUserAlt } from 'react-icons/fa'
import { ReactComponent as ReactLogo } from '../../assets/images/nevula-chat-icon.svg'
import { ThemeContext } from '../../context/ThemeContext'
import { IMessage } from './VirtualAssistantPage'
import saveAs from 'file-saver'

const Message: React.FC<IMessageProps> = ({ body, user, time, message }) => {

  const controls = useAnimation()

  const { theme } = useContext(ThemeContext)

  useEffect(() => {
    controls.start({
      y: 0,
      opacity: 1,
      transition: {
        duration: 1,
        ease: "easeInOut",
      }
      // zIndex: 1
    });
  }, [])
  

  const messageContainer = () => {
    if (user === 'assistant') {
      return {
        borderTopLeftRadius: 25,
        borderBottomLeftRadius: 1,
        borderTopRightRadius: 6,
        borderBottomRightRadius: 6,
      }
    }
    return {
      borderTopLeftRadius: 6,
      borderBottomLeftRadius: 6,
      borderTopRightRadius: 25,
      borderBottomRightRadius: 1,
    }
  }

  return (
    <motion.div animate={controls} initial={{y: 5, opacity: 0}}>
      <div
        className={`flex items-end`}
        style={{
          flexDirection: user === 'assistant' ? 'row' : 'row-reverse',
          justifyContent: user === 'assistant' ? 'start' : 'end',
        }}
      >
        <div
          style={{ height: 70, width: 70 }}
          className={`flex ${
            user === 'assistant' ? 'flex-row items-end' : 'flex-col'
          }`}
        >
          <div
            style={{
              height: 60,
              width: 60,
              backgroundColor: user === 'assistant' ? '#006AEA' : '#0033A0',
              borderRadius: 50,
              borderWidth: 4,
              borderStyle: 'solid',
              borderColor: '#ECECEC',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            {user === 'assistant' ? (
              <ReactLogo />
            ) : (
              <FaUserAlt style={{ color: '#FFFFFF' }} size={20} />
            )}
          </div>

          <div
            style={{
              height: 12,
              width: 12,
              backgroundColor: user === 'assistant' ? '#006AEA' : '#0033A0',
              borderRadius: 50,
            }}
          ></div>
        </div>

        <div>
          <div
            className={`flex flex-row items-end ${
              user === 'assistant' ? 'ml' : 'mr'
            }-5`}
          >
            <div
              style={{
                minHeight: 40,
                backgroundColor: user === 'assistant' ? '#006AEA' : '#85818129',
                ...messageContainer(),
                maxWidth: 400,
              }}
              className="p-3 flex flex-col justify-center"
            >
              <label
                style={{
                  color: user === 'assistant' ? 'white' : theme === "dark" ? 'white' : 'black' ,
                  wordBreak: 'break-word',
                }}
              >
                {/* {body} */}
                {message?.content}
              </label>

              {message?.fileToRender && message?.fileInfo?.type == 'file' && (
                  <label
                    style={{
                      color: 'white',
                      wordBreak: 'break-word',
                      textDecoration: 'underline',
                      cursor: 'pointer',
                      // marginLeft: 90,
                      marginTop: 30,
                      fontWeight: 'bold',
                      display: 'block'
                    }}
                    onClick={() => {
                      saveAs(
                        message?.fileToRender!,
                        message?.fileInfo?.file_name!
                      )
                    }}
                  >
                    {`Descargar ${message?.fileInfo?.file_name}`}
                  </label>
                )}

            </div>
          </div>
          <div
            className={`flex flex-row justify-end ${
              user === 'assistant' ? 'ml' : 'mr'
            }-5`}
          >
            <label style={{color: theme === "dark" ? "#DFDFDF" : "#838383"}}>{time}</label>
          </div>
        </div>
      </div>
    </motion.div>
  )
}

interface IMessageProps {
  body: string
  user: 'user' | 'assistant'
  time: string
  message: IMessage
}

export default Message
function useAnimationControls() {
  throw new Error('Function not implemented.')
}

